export type CardTransformerFunction<ValueT = any> = (x: ValueT) => ValueT;

export type CardTransformer<T = any> = {
  [key in keyof T]?: (item: T[key]) => T[key];
}

export type CardTransformerHandler<T = any> = (x: T) => T

export const transform = <T = any>(transformer: CardTransformer<T>): CardTransformerHandler<T> => {
  if (!transformer) return (x): T => x;

  const transformFns = Object.entries(transformer) as [keyof T, CardTransformerFunction][];

  return (item: T): T => {
    if (!transformer) return item;

    const transformedItem = transformFns
      .reduce((acc, [prop, fn]) => {
        acc[prop] = fn(item[prop]);
        return acc;
      }, item as T);

    return {
      ...item,
      ...transformedItem,
    };
  };
};
